var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7L12 3M12 3L16 7M12 3V8.394M12 8.394C12.0001 9.50318 11.7263 10.5952 11.2029 11.5732C10.6796 12.5511 9.9229 13.3847 9 14C8.0771 14.6153 7.3204 15.4489 6.79705 16.4268C6.27371 17.4048 5.99992 18.4968 6 19.606V21M12 8.394C11.9999 9.50318 12.2737 10.5952 12.7971 11.5732C13.3204 12.5511 14.0771 13.3847 15 14C15.9229 14.6153 16.6796 15.4489 17.2029 16.4268C17.7263 17.4048 18.0001 18.4968 18 19.606V21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/Merge.91a9dfedd07aba8070c4998037f62a51.svg";
export { ForwardRef as ReactComponent };